import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Cargamos los plugins
dayjs.extend(utc);
dayjs.locale('es')
dayjs.extend(timezone);
export const formatoFechaHora =(fecha) =>{
    if (!fecha) {
        return ''
    }

    const userTimezone = dayjs.tz.guess();

    return dayjs(fecha).tz(userTimezone).format('HH :mm:a');
}